module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav-bar"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/all"
    }
  }, [_vm._v("全部")])], 1), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/untreated"
    }
  }, [_vm._v("待处理")])], 1), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/over"
    }
  }, [_vm._v("已完成")])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/add"
    }
  }, [_c('span', {
    staticClass: "btn-add"
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon_logo.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("记事本")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5008b2ef","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 34
// module chunks = 0